"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _CardMedia = _interopRequireDefault(require("@material-ui/core/CardMedia"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  card: {
    width: '16em',
    backgroundColor: props => {
      return props.backgroundColor;
    }
  },
  cardMedia: {
    width: "100%",
    paddingBottom: props => {
      return 9 / 16 * 100 + "%";
    }
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    padding: "0.5em 1em",
    justifyContent: props => {
      return props.justifyContent;
    },
    alignItems: props => {
      return props.alignItems;
    }
  },
  title: {
    fontSize: "2em",
    lineHeight: 1.2,
    "& + $description": {
      marginTop: theme.spacing(1)
    }
  },
  description: {
    fontSize: "1em",
    opacity: 0.8
  }
}));

const getTextPlacement = ({
  placement = "top-left"
}) => {
  let justifyContent = "center";
  let alignItems = "center"; // horizontal

  if (placement.includes('left')) {
    alignItems = "flex-start";
  } else if (placement.includes('right')) {
    alignItems = "flex-end";
  } // vertical


  if (placement.includes('top')) {
    justifyContent = "flex-start";
  } else if (placement.includes('bottom')) {
    justifyContent = "flex-end";
  }

  return {
    justifyContent: justifyContent,
    alignItems: alignItems
  };
};

const MosaicModule = (_ref) => {
  let imageUrl = _ref.imageUrl,
      title = _ref.title,
      description = _ref.description,
      skin = _ref.skin,
      width = _ref.width,
      height = _ref.height,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["imageUrl", "title", "description", "skin", "width", "height", "onClick"]);

  const _getTextPlacement = getTextPlacement(props),
        justifyContent = _getTextPlacement.justifyContent,
        alignItems = _getTextPlacement.alignItems;

  const classes = useStyles(_extends({}, props, {
    backgroundColor: "white",
    justifyContent,
    alignItems
  }));
  return _react.default.createElement(_Card.default, {
    className: classes.card,
    onClick: onClick
  }, imageUrl && _react.default.createElement(_CardMedia.default, {
    className: classes.cardMedia,
    alt: title,
    image: imageUrl,
    title: title
  }), _react.default.createElement(_CardContent.default, {
    className: classes.cardContent
  }, _react.default.createElement(_Typography.default, {
    className: classes.title,
    variant: "h6",
    component: "h2"
  }, title), description && _react.default.createElement(_Typography.default, {
    className: classes.description,
    variant: "body2",
    color: "textSecondary",
    component: "p"
  }, description)));
};

var _default = MosaicModule;
exports.default = _default;
module.exports = exports.default;